//lazy selection
import globalBus from '@/services/evbus';
import store from '@/store'
import { debounce, cloneDeep } from 'lodash';

let selected: any[] = [];

globalBus.on('clear-table-selection', () => {
    if(selected.length) {
        store.commit('tableSelectedItems', []);
        store.commit('tableNextReportGroup', null);
    }

    selected = [];
});

globalBus.on('refresh-table-selection', () => {
    selected = cloneDeep(store.state.table.selectedItems);
});

export function normalizeId(id: string) {
    const regex = /\[(.+)\]$/;
    let result = id;

    if(id && id.indexOf('with-prefix') === 0) {
        const match = id.match(regex);
        if(match) {
            result = match[1];
        }
    }

    return result;
}

export default debounce( (ev: MouseEvent, self: any, items: any, single: boolean = false, contextMenu: boolean = false, treeLevel: number = 0) => {
    let isArray = Array.isArray(items)
    if (ev) ev.stopPropagation();

    if (!ev || !items || isArray)
    //cleanup if null is passed
    {
        let selected: any = self?.$el?.querySelectorAll('.datatable__row-selected, .datatable__row-selected .fa-check-square') || [];

        //fix NodeList issue for old browsers
        if(!selected.forEach) {
            selected = Array.from(selected);
        }
        
        selected.forEach((e: HTMLElement)=>{
            e.classList.remove('datatable__row-selected');
            if(e.classList.contains('fa-check-square'))
            {
                e.classList.remove('fa-check-square');
                e.classList.add('fa-square');
            }
        });

        if(!isArray)
            return;
    }

    try {
        if(!isArray) {
            items = [ items ];
        } else {
            single = false;
            selected = [];
        }

        let swapped: any = undefined;
        let selectedLength = selected.length;
        let diffAdd: string[] = [];

        if (single) {
            swapped = selected.find((e: any) =>  e.DT_RowId === items[0].DT_RowId);
            selected = [];

            let rows = self?.$el?.getElementsByClassName('datatable-row');
            for(let i in rows) {
                if(rows.hasOwnProperty(i)) {
                    let target = rows[i] as HTMLElement;
                    let id = target.dataset.id;

                    target.classList.remove('datatable__row-selected');
                    target.classList.remove('focus');

                    const escapedId = id.replace('"', '&quot;');

                    let checkbox = self?.$el?.querySelector(`.v-input[data-id="${escapedId}"] i`) as HTMLElement;
                    if (checkbox) {
                        checkbox.classList.add('fa-square');
                        checkbox.classList.remove('fa-check-square');
                    }
                }
            }
        }

        for(let item of items) {
            // if(normalizeId(item.DT_RowId) === 'Unknown') {
            //     continue;
            // }

            let index = selected.findIndex((e: any) => e.DT_RowId === item.DT_RowId);

            if (!isArray && (index !== -1 || swapped)) {
                selected.splice(index, 1);

                const escapedId = (item.DT_RowId + '').replace('"', '&quot;');

                let target = self?.$el?.querySelector(`tr[data-id="${escapedId}"]`) as HTMLElement;
                if (target) {
                    target.classList.remove('datatable__row-selected');
                    target.classList.remove('focus');
                }

                let checkbox = self?.$el?.querySelector(`.v-input[data-id="${escapedId}"] i`) as HTMLElement;
                if (checkbox) {
                    checkbox.classList.add('fa-square');
                    checkbox.classList.remove('fa-check-square');
                    checkbox.classList.remove('fas');
                    checkbox.classList.remove('accent--text');
                    checkbox.classList.add('far');
                }
                
                if (contextMenu || (!contextMenu && swapped && selectedLength > 1)) {
                    selected.push(swapped);
                    diffAdd.push(swapped.DT_RowId);
                }
                    
            } else {
                selected.push({
                    DT_RowId: item.DT_RowId,
                    DT_RowName: item.DT_RowName,
                    DT_RowStatus: item.DT_RowStatus,
                    DT_RowWorkspaceId: item.DT_RowWorkspaceId,
                    DT_RowUrl: item.DT_RowUrl,
                    grouping: self.grouping,
                    isDirect: !item.DT_RowStatus && !item.DT_RowUrl,
                })
                diffAdd.push(item.DT_RowId);
            }
        }

        diffAdd.forEach((id: string | number) => {
            const escapedId = (id + '').replace('"', '&quot;');

            let target = self?.$el?.querySelector(`tr[data-id="${escapedId}"]`) as HTMLElement;
            if(target) {
                target.classList.add('datatable__row-selected');
                target.classList.add('focus');
            }

            let checkbox = self?.$el?.querySelector(`.v-input[data-id="${escapedId}"] i`) as HTMLElement;
            if (checkbox) {
                checkbox.classList.remove('fa-square');
                checkbox.classList.add('fa-check-square');
                checkbox.classList.remove('fas');
                checkbox.classList.remove('accent--text');
                checkbox.classList.add('far');
            }
        });

        const eventData = selected.map((item) => {
            return {
                ...item,
                DT_RowId: normalizeId(item.DT_RowId)
            }
        });

        if (contextMenu && selected.length > 0) {
            globalBus.emit('clear-row-context');
            setTimeout(() => globalBus.$emit('row-contextmenu', eventData, ev.clientY, ev.clientX, treeLevel), 100);
        }

      self.$emit('row-selected', eventData, treeLevel);
    }
    catch(e){
        console.log('table selection: redraw exception', e)
    }
},0);
